<template>
	<NuxtLoadingIndicator color="green"/>

	<!-- <div> -->
	<NuxtLayout>
		<NuxtPage />
	</NuxtLayout>

	<UNotifications />
	<!-- </div> -->

	<UModals />
</template>

<script setup lang="ts">
import { PROJECT } from '~/config/project'

useHead({
	script: [
		{ src: 'https://telegram.org/js/telegram-web-app.js?57' }
	],
	titleTemplate: (titleChunk) => {
		return titleChunk ? `${titleChunk} - ${PROJECT.title}` : PROJECT.title;
	}
})

onMounted(() => {
  if ('serviceWorker' in navigator) {
	navigator.serviceWorker
	  .register('/sw.js')
	  .then((registration) => {
		console.log('Сервис-воркер зарегистрирован:', registration);
	  })
	  .catch((error) => {
		console.error('Ошибка регистрации сервис-воркера:', error);
	  });
  }
});
</script>
